import { CompetitionNavBettingOddsState } from '../types';
import { ReduxState } from '../types';

/**
 * @param {ReduxState} state - The Redux state.
 * @returns {CompetitionNavBettingOddsState} The Competition Nav Betting Odds state.
 */
export const bettingOddsSelector = (state) =>
    state.competitionNav.nav.bettingOdds;
